import { motion } from "framer-motion";
import { Mail, Instagram, Facebook, Globe, ArrowUpRight } from "lucide-react";
import { EASE } from "@/lib/scroll";

const CHANNELS = [
  {
    icon: Mail,
    label: "Email",
    value: "nosenpetfood@yahoo.com",
    href: "mailto:nosenpetfood@yahoo.com",
    testid: "contact-link-email",
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: "@nosapetfood",
    href: "https://www.instagram.com/nosapetfood",
    testid: "contact-link-instagram",
  },
  {
    icon: Facebook,
    label: "Facebook",
    value: "NOSA Pet Food",
    href: "https://www.facebook.com/share/18RoqYH3HS/?mibextid=wwXIfr",
    testid: "contact-link-facebook",
  },
  {
    icon: Globe,
    label: "Website",
    value: "nosenpetfood.ro",
    href: "https://nosenpetfood.ro",
    testid: "contact-link-website",
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative overflow-hidden border-t border-gold/10 bg-[#141311] py-24 lg:py-36"
    >
      <div className="pointer-events-none absolute left-1/2 top-0 h-[60vh] w-[80vw] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.1)_0%,rgba(17,17,17,0)_65%)]" />
      <div className="relative mx-auto max-w-5xl px-6 text-center lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="mb-6 flex items-center justify-center gap-4">
            <span className="h-px w-12 bg-gold/70" />
            <p className="font-mono text-[10px] uppercase tracking-[0.38em] text-gold sm:text-[11px]">
              Contact
            </p>
            <span className="h-px w-12 bg-gold/70" />
          </div>
          <h2 className="mx-auto max-w-2xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
            Să vorbim despre <em className="text-gold-gradient">pisica ta.</em>
          </h2>
          <p className="mx-auto mt-8 max-w-md text-sm leading-relaxed text-stone lg:text-base">
            Pentru comenzi, parteneriate sau orice întrebare despre formula NOSA, găsești
            echipa noastră pe canalele de mai jos.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CHANNELS.map((c, i) => (
            <motion.a
              key={c.label}
              href={c.href}
              target={c.href.startsWith("mailto") ? undefined : "_blank"}
              rel="noopener noreferrer"
              data-testid={c.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              className="group flex flex-col items-center gap-5 rounded-3xl border border-gold/15 bg-card/60 px-6 py-10 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_24px_60px_rgba(212,175,55,0.12)]"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-full border border-gold/30 text-gold transition-all duration-500 group-hover:bg-gold group-hover:text-ink">
                <c.icon size={22} strokeWidth={1.5} />
              </span>
              <span className="flex flex-col items-center gap-1.5">
                <span className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold/70">
                  {c.label}
                </span>
                <span className="break-all text-sm text-cream">{c.value}</span>
              </span>
              <ArrowUpRight
                size={16}
                className="text-gold/40 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-gold"
              />
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
          className="mt-16"
        >
          <a
            href="mailto:nosenpetfood@yahoo.com"
            data-testid="contact-cta-email"
            className="inline-block rounded-full bg-gold px-12 py-5 font-mono text-[11px] uppercase tracking-[0.26em] text-ink transition-all duration-500 hover:bg-gold-light hover:shadow-[0_18px_60px_rgba(212,175,55,0.3)]"
          >
            Scrie-ne un email
          </a>
        </motion.div>
      </div>
    </section>
  );
}
